import { ProtectedJsonAPI } from './ProtectedJsonAPI'

export const AppVersion = ProtectedJsonAPI.extend(
  '',
  {
    tag:   endpoint => endpoint.path(() => "tag"),
  }
)